import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'ed-datepicker',
    templateUrl: './ed-datepicker.component.html',
})
export class EdDatepickerComponent {
    @Input() date?: Date;
    @Input() disabled: boolean = false;
    @Output() dateChange = new EventEmitter<Date>();

    onDateChanged(selectedDate: string) {
        const newDate = new Date(selectedDate);
        this.dateChange.emit(newDate);
    }
}
